export default __webpack_public_path__ + "static/langfuse-409ff56e83417c4f63f3beb0a00713ee.png";